<template>
  <div>
    <div class="loginPage">
      <div class="login" >
        <img class="login-close" src="@/assets/imgs/login-close.png" alt=""  @click="closeHandle">
        <div class="login_header">
          <div class="login_header_right">
            <p>忘记密码</p>
          </div>
        </div>
        <div class="login-input">
          <div class="login-account" :class="fphoneError ? 'error' :''">
            <input type="number" v-model.trim="fphone" placeholder="请输入注册时使用的手机号" :class="{ 'error-input': fphoneError }" @input="fphoneError = ''">
            <div class="error-tip" v-if="fphoneError">{{ fphoneError }}</div>
          </div>
          <div class="login-account flex " :class="fphoneCodeError ? 'error' :''">
            <div style="width: 200px;">
              <input style="width: 200px;" type="text" v-model.trim="fphoneCode" placeholder="请输入验证码" :class="{ 'error-input': fphoneCodeError }" @input="fphoneCodeError = ''">
              <div class="error-tip" v-if="fphoneCodeError">{{ fphoneCodeError }}</div>
            </div>
            <div class="send-btn sended" v-if="showSendTime > 0">已发送（{{ showSendTime }}s）</div>
            <div class="send-btn" v-else @click="clickSend" v-loading="showSendLoding">发送验证码</div>
          </div>
          <div class="login-account" :class="fpassword1Error ? 'error' :''">
            <input type="password" ref="fpasswordRef1" v-model.trim="fpassword1" placeholder="新密码" :class="{ 'error-input': fpassword1Error }" @input="fpassword1Error = ''">
            <img v-if="fisP1" src="@/assets/imgs/password-see.png" alt="" @click="fclickPassword1">
            <img v-else src="@/assets/imgs/password-hidden.png" alt="" @click="fclickPassword1">
            <div class="error-tip" v-if="fpassword1Error">{{ fpassword1Error }}</div>
          </div>
          <div class="login-account" :class="fpassword2Error ? 'error' :''">
            <input type="password" ref="fpasswordRef2" v-model.trim="fpassword2" placeholder="确认密码" :class="{ 'error-input': fpassword2Error }" @input="fpassword2Error = ''">
            <img v-if="fisP2" src="@/assets/imgs/password-see.png" alt="" @click="fclickPassword2">
            <img v-else src="@/assets/imgs/password-hidden.png" alt="" @click="fclickPassword2">
            <div class="error-tip" v-if="fpassword2Error">{{ fpassword2Error }}</div>
          </div>

        </div>
        <div class="login-btn" @click="resetAIPasswordM">重置密码</div>
      </div>
    </div>
    <el-dialog v-model="showSlider" title="请拖动滑块验证" width="400px">
       <div class="slider-wrap" v-if="showSlider">
          <Check style="width: 330px;" @success="checkHandle"></Check>
       </div>
    </el-dialog>
  </div>
</template>


<script setup>
import { ref, onUnmounted } from 'vue';
import Check from './components/slider-check.vue';
import { userLogin,  sendAIPhone, registerAIAccount, resetAIPassword } from '@/api/index';
import AES from '@/utils/AES';
import location from "@/utils/location";
const domain = location.domain();
import useHomeStore from '@/store/home'
import { ElMessage } from 'element-plus';
import router from '@/router';
const homeStore = useHomeStore()

const showSlider = ref(false)
// 验证
const checkFlag = ref(false);
const checkHandle = async (val) => {
  checkFlag.value = val;
  await fsendAIPhoneM()
  showSlider.value = false
};

//重置密码
const fphone = ref()
const fphoneCode = ref()
const fpassword1 = ref()
const fpassword2 = ref()

// 错误提示
const fphoneError = ref('');
const fphoneCodeError = ref('');
const fpassword1Error = ref('');
const fpassword2Error = ref('');

// 密码校验
function checkPassword(str) {
  const regex = /^(?:(?=.*[a-zA-Z])(?=.*[\d])(?!.*\s)|(?=.*[a-zA-Z])(?=.*[^a-zA-Z\d\s])(?!.*\s)|(?=.*[\d])(?=.*[^a-zA-Z\d\s])(?!.*\s)).{8,20}$/;
  const regex1 = /[\u4e00-\u9fa5]/;
  return regex.test(str) && !regex1.test(str);
}


const showSendTime = ref(0) // 倒计时剩余秒数，0表示未开始或已结束
const showSendLoding = ref(false)
let countdownTimer = null // 倒计时定时器

// 开始倒计时
const startCountdown = () => {
  showSendTime.value = 300 // 从60秒开始
  // 清除之前的定时器（如果有）
  if (countdownTimer) {
    clearInterval(countdownTimer)
  }
  // 开始倒计时
  countdownTimer = setInterval(() => {
    showSendTime.value--
    if (showSendTime.value <= 0) {
      clearInterval(countdownTimer)
      countdownTimer = null
      showSendTime.value = 0
    }
  }, 1000)
}
const clickSend = () => {
  fphoneError.value = '';
  if (!fphone.value) {
    fphoneError.value = '请输入手机号！'
    return;
  }
  if (!/^1[3-9]\d{9}$/.test(fphone.value)) {
    fphoneError.value = '请输入正确的手机号'
    return
  }
  showSlider.value = true
}

const fsendAIPhoneM = async () => {
  fphoneError.value = '';
  if (!fphone.value) {
    fphoneError.value = '请输入手机号！'
    return;
  }
  if (!/^1[3-9]\d{9}$/.test(fphone.value)) {
    fphoneError.value = '请输入正确的手机号'
    return;
  }
  if (!checkFlag.value.flag) {
    ElMessage.warning('请滑动滑块验证！')
    return;
  }
  showSendLoding.value = true
  const res = await sendAIPhone({
    "sendType": 2,//1、注册  2、忘记密码
    "phone": fphone.value, //手机号
    "verifyImageResult": {
      captchaSerialNumber: checkFlag.value.imgSwipe.captchaSerialNumber,
      moveEnd_X: checkFlag.value.width,
      wbili: 1
    }
  })
  if(res.code == 0 && res.data == 1){
    ElMessage.success('已发送验证码')
    showSendLoding.value = false
    startCountdown() // 开始倒计时
  }else if(res.data == 4){
    ElMessage.warning('短信已发送')
     showSendLoding.value = false
  }else if(res.data == 5){
    ElMessage.warning('该手机号未注册')
    showSendLoding.value = false
  }else{
    ElMessage.warning(res.msg)
    showSendLoding.value = false
  }
}


// 组件卸载时清理定时器
onUnmounted(() => {
  if (countdownTimer) {
    clearInterval(countdownTimer)
    countdownTimer = null
  }
})

//重置密码
const resetAIPasswordM = async () => {
  // 清除之前的错误提示
  fphoneError.value = '';
  fphoneCodeError.value = '';
  fpassword1Error.value = '';
  fpassword2Error.value = '';
  
  let hasError = false;
  
  if (!fphone.value) {
    fphoneError.value = '请输入手机号！'
    hasError = true;
  } else if (!/^1[3-9]\d{9}$/.test(fphone.value)) {
    fphoneError.value = '请输入正确的手机号'
    hasError = true;
  }
  
  if (!fphoneCode.value) {
    fphoneCodeError.value = '请输入验证码！'
    hasError = true;
  }
  
  if (!fpassword1.value) {
    fpassword1Error.value = '请输入新密码！'
    hasError = true;
  } else if (!checkPassword(fpassword1.value)) {
    fpassword1Error.value = '密码长度在8~20位之间，字母、数字、特殊符号至少包含2种'
    hasError = true;
  }
  
  if (!fpassword2.value) {
    fpassword2Error.value = '请再次输入密码！'
    hasError = true;
  } else if (fpassword1.value !== fpassword2.value) {
    fpassword2Error.value = '两次输入密码不一致！'
    hasError = true;
  }
  
  if (hasError) {
    return;
  }
  
  const res = await  resetAIPassword({
    "password": fpassword1.value, //密码
    "phone": fphone.value, //手机号
    "phoneCode": fphoneCode.value //短信验证码
  })
  if(res.code == 0 && res.data == 0){
    ElMessage.success('重置成功')
    setTimeout(() => {
      closeHandle()
    }, 1000);
  }else if(res.data == 1){
    ElMessage.error('重置失败')
  }else if(res.data == 2){
    ElMessage.error('验证码输入有误')
  }else if(res.data == 3) {
    ElMessage.error('该手机号未注册')
  }
}



// 关闭
const closeHandle = () => {
  homeStore.changeLogin();
  homeStore.changeForget();
};

//点击显示密码

const fpasswordRef1 = ref()
const fisP1 = ref(false);
const fclickPassword1 = () => {
  fpasswordRef1.value.type = fpasswordRef1.value.type == 'text' ? 'password' : 'text';
  fisP1.value = fpasswordRef1.value.type == 'text' ? true : false;
}
const fpasswordRef2 = ref()
const fisP2 = ref(false);
const fclickPassword2 = () => {
  fpasswordRef2.value.type = fpasswordRef2.value.type == 'text' ? 'password' : 'text';
  fisP2.value = fpasswordRef2.value.type == 'text' ? true : false;
}

</script>

<style scoped lang='scss'>

//移除 Edge 浏览器对 input[type="password"]默认显示的密码切换图标（眼睛图标）
input[type="password"]::-ms-reveal {
  display: none !important; /* 强制覆盖默认样式 */
  width: 0 !important;      /* 可选：消除图标占位空间 */
  height: 0 !important;     /* 可选：同上 */
}

.slider-wrap{
  display: flex;
  justify-content: center;
  width: 350px;
  margin:0 auto;
  margin-top: 250px;
}
.check-wrap{
  display: flex;
  justify-content: center;
}
.mt24{
  margin-top: 24px;
}
.loginPage {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  .login {
    background: #FFFFFF;
    border-radius: 16px;
    position: fixed;
    top: calc(50vh - 340px);
    left: calc(50vw - 205px);
    padding: 48px 40px;
    box-sizing: border-box;
    .login-close{
      position: absolute;
      right: 24px;
      top: 24px;
      cursor: pointer;
    }
    .login_header {
      display: flex;
      margin-bottom: 48px;
      img {
        width: 64px;
        height: 64px;
        margin-right: 24px;
      }
      .login_header_right {
        p:nth-child(1) {
          font-family: MicrosoftYaHei-Bold;
          font-size: 24px;
          color: #161616;
          letter-spacing: 0;
          font-weight: 700;
        }
        p:nth-child(2) {
          font-family: MicrosoftYaHei;
          font-size: 16px;
          color: #666666;
          letter-spacing: 0;
          font-weight: 400;
          margin-top: 6px;
        }
      }
    }
    .tips {
      margin-left: 16px;
      font-family: MicrosoftYaHei;
      font-size: 14px;
      color: #FF0000;
      letter-spacing: 0;
      font-weight: 400;
      height: 20px;
      margin-top: 24px;
      opacity: 0;
      &.showTips {
        opacity: 1;
      }
    }
    .login-input {
      margin-bottom: 24px;
      input {
        width: 330px;
        height: 48px;
        box-sizing: border-box;
        background: #ffffff;
        border: 1px solid rgba(236, 236, 236, 1);
        border-radius: 4px;
        padding-left: 16px;
        padding-top: 8px;
        &::placeholder {
          font-family: MicrosoftYaHei;
          font-size: 16px;
          color: #bbbbbb;
          font-weight: 400;
        }
      }
      input:focus-visible {
        border-color: rgba(236, 236, 236, 1);
        box-shadow: none;
        outline: none;
        border: 1px solid rgba(27,132,255,1);
      }
      input.error-input {
        border: 1px solid rgba(255,23,23,1);
      }
      input.error-input:focus-visible {
        border: 1px solid rgba(255,23,23,1);
      }
      /* 1. 针对 Firefox 浏览器 */
      input[type="number"] {
        -moz-appearance: textfield; /* 移除 Firefox 内置的数字箭头 */
        appearance: textfield; /* 标准属性，兜底 */
      }

      /* 2. 针对 Webkit/Chromium 浏览器（Chrome、Safari、新版 Edge） */
      input[type="number"]::-webkit-inner-spin-button,
      input[type="number"]::-webkit-outer-spin-button {
        -webkit-appearance: none; /* 移除 Webkit 内置的 spin 按钮 */
        margin: 0; /* 清除默认边距，避免输入框内部布局异常 */
      }

      /* 3. 针对旧版 IE/Edge（IE10+）【可选，现代浏览器可忽略】 */
      input[type="number"]::-ms-inner-spin-button {
        display: none; /* 移除 IE 内置的 spin 按钮 */
      }

      /* 可选：保持输入框样式一致性（如禁用焦点轮廓、自定义样式） */
      input[type="number"] {
        padding: 8px 12px;
        // border: 1px solid #ddd;
        border-radius: 4px;
        outline: none;
      }
      /* IE11兼容 */
      @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
        input:focus {
          border-color: rgba(236, 236, 236, 1);
        }
      }
      .login-account {
        position: relative;
        margin-bottom: 24px;
        &.error{
          margin-bottom: 8px;
        }
        &.flex{
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
        }

        img {
          position: absolute;
          right: 14px;
          top: 13px;
          width: 24px;
          cursor: pointer;
        }
        .send-btn{
          width: 117px;
          height: 48px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #FFFFFF;
          border: 1px solid rgba(236,236,236,1);
          border-radius: 6px;
          cursor: pointer;
          &.sended{
            font-family: PingFangSC-Regular;
            font-size: 16px;
            color: #95AAB9;
            font-weight: 400;
          }
        }
        .error-tip {
          margin-top: 2px;
          font-family: PingFangSC-Regular;
          font-size: 12px;
          color: #FF0000;
          font-weight: 400;
        }
      }
    }
    .login-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 24px;
      margin-bottom: 24px;
      width: 330px;
      height: 48px;
      background-image: linear-gradient(90deg, #3BE1F9 0%, #3363FF 50%, #9377FF 100%);
      border-radius: 4px;
      font-family: MicrosoftYaHei-Bold;
      font-size: 20px;
      color: #ffffff;
      font-weight: 700;
      cursor: pointer;
    }
    .login-other {
      display: flex;
      justify-content: space-between;
      span {
        cursor: pointer;
        color: #1B84FF;
        &:hover {
          color: #1B84FF;
        }
      }
    }
  }
}
.back-login{
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: PingFangSC-Regular;
  font-size: 18px;
  color: #1B84FF;
  font-weight: 400;
  cursor: pointer;
}


</style>